import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import logo from "../../images/Charter-Logo.png";
import bg from "../../images/systemBg.jpg";
import { toast } from "react-toastify";
import api from "../../api/axiosInstance";
const ResetPassword = () => {
  const pId = useParams();
  const navigate = useNavigate();
  const [session, setSession] = useState(true);
  const [submitted] = useState(false);
  const [password, setPassword] = useState("");

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handlePasswordConfirmation = (e) => {};

  const resetPassword = (e) => {
    var userId = pId.UserId;
    var tempPassword = password;
    var data = { userId, tempPassword };
    var config = {
      method: "post",
      url: process.env.REACT_APP_API_URL + "Users/UpdateTempPassword",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      data: data,
    };

    api(config)
      .then(function (response) {
        console.log(response);
        if (response.data.statusCode === 200) {
          toast.success(response.data.message);
          navigate("/login");
        } else {
          toast.error("Please check with support");
        }
      })
      .catch(function (error) {
        toast.error("Please check with support");
      });
  };

  const checkTempPassword = (userId, tempPassword) => {
    //   debugger;
    var data = { userId, tempPassword };
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API_URL + "Users/CheckTempPassword",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
      data: data,
    };

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          setSession(true);
        } else {
          setSession(false);
        }
      })
      .catch(function (error) {
        setSession(false);
      });
  };

  useEffect(() => {
    checkTempPassword(pId.UserId, pId.TempPassword);
  }, [pId.UserId, pId.TempPassword]);
  return (
    <>
      {session === true ? (
        <>
          <div
            className="container-fluid h-100vh loginPage"
            style={{ backgroundImage: `url(${bg})` }}
          >
            <div className="row align-items-center justify-content-center">
              <div className="col-md-10 col-lg-8 col-xl-6 col-xxl-4 login-box">
                <img src={logo} className="logo" alt="CTS HR System Logo" />
                <div className="row">
                  <div className="col-12 mb-3">
                    <h3>Welcome to Canvas Analyzer Portal</h3>
                    <h4>Reset Password</h4>
                    <p>
                      Make sure the password meets the password complex policy
                    </p>
                  </div>
                  <div className="col-12 mb-1">
                    <input
                      type="password"
                      placeholder="Password"
                      name="email"
                      autocomplete="off"
                      className="form-control bg-transparent"
                      onChange={(e) => handlePassword(e)}
                    />
                  </div>
                  <div className="col-12 mb-3">
                    <input
                      type="password"
                      placeholder="Confirm Password"
                      name="email"
                      autocomplete="off"
                      className="form-control bg-transparent"
                      onChange={(e) => handlePasswordConfirmation(e)}
                    />
                  </div>
                  <div className="col-12">
                    <button
                      type="button"
                      id="kt_password_reset_submit"
                      className="btn btn-primary me-4"
                    >
                      {submitted === false ? (
                        <span
                          className="indicator-label"
                          onClick={(e) => resetPassword(e)}
                        >
                          Submit
                        </span>
                      ) : (
                        <span className="indicator-progress">
                          Please wait...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
                <p className="footer-login-box">
                  Developed By: CTS - All Rights Reserved - V1.0.2023
                </p>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <h1>Reset Link Expired</h1>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ResetPassword;
